import {
  toast
} from 'react-toastify';

import {
  setLocalStorage,
  removeLocalStorage
} from '../../../utils/web-storage';
import axiosService from '../../../inits/axios';
import {
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_SUCCESS,
  SET_CATEGORIES
} from './auth.actiontype';
import logs from '../../../components/Common/HistoryLogs';

export const login = (userCredential) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LOGIN_START,
    });

    const tokenInfo = await axiosService.post('/login', userCredential);

    if (!tokenInfo || !tokenInfo.token) {
      throw new Error('Invalid response: No token received');
    }

    setLocalStorage('accessToken', tokenInfo.token);


    toast.success('You are successfully logged in.');

    // Force page reload to trigger route change
    setTimeout(() => {
      window.location.href = '/analytics';
    }, 1000);

  } catch (error) {
    console.error('Login error:', error);
    const errorMssg = error.errors ? error.errors.email[0] : error.message || error;
    removeLocalStorage('accessToken');

    dispatch({
      type: LOGIN_ERROR,
      payload: error,
    });

    toast.error(errorMssg);
  }
};

export const getCurrentUser = (accessToken) => async (dispatch, getState) => {
  try {
    const userInfo = await axiosService.get('/profile');

    if (!userInfo) {
      throw new Error('No user information received');
    }

    dispatch({
      type: LOGIN_SUCCESS,
      payload: {
        user: userInfo,
        accessToken,
      },
    });

    if (userInfo.role === 'user') {
      throw new Error('User login not allowed');
    }

    logs.pieces = {
      ...logs.pieces,
      "Username": userInfo.name,
      "Email": userInfo.email,
    };

    return Promise.resolve(userInfo);
  } catch (error) {
    console.error('Get current user error:', error);
    removeLocalStorage('accessToken');

    dispatch({
      type: LOGIN_ERROR,
      payload: error,
    });

    return Promise.reject(error);
  }
};

export const removeUser = () => async (dispatch, getState) => {
  removeLocalStorage('accessToken');
  dispatch({
    type: LOGOUT_SUCCESS,
  });
  // Force redirect to login
  window.location.href = '/';
};

export const setCategories = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_CATEGORIES,
    payload: data,
  });
};

